import { type HTMLAttributes, type ReactElement } from 'react';

import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactElement {
  return (
    <div
      className={cn('skeleton-shimmer rounded-[var(--radius-md)]', className)}
      {...props}
    />
  );
}
